import React from 'react';
import { useParams } from 'react-router-dom';
import './CoursePage.css';

const CoursePage = () => {
  const { subcategory } = useParams();

  return (
    <div className="course-page">
      <h1>{subcategory.replace(/-/g, ' ')} Courses</h1>
      <p>Welcome to the {subcategory.replace(/-/g, ' ')} course page!</p>
      {/* Add course content here */}
    </div>
  );
};

export default CoursePage;
